export default __webpack_public_path__ + "static/media/Armbands of the Merciless.474bf5a3.jpg";